// Pathify
import {make} from 'vuex-pathify'
import api from "@/services/api";
import {toast} from '@/util/helpers';
import Models from "../../models";

// Data
const state = {
	courses:[],
	course: Models.Resource('Course'),
}

const getters = make.getters(state)

const mutations = make.mutations(state)

const actions = {
	...make.actions(state),
	getCourses: ({ dispatch }) => {
		api.courses.index()
			.then(response => dispatch('setCourses', response.data))
			.catch(error => toast.add(error.message, 'error'))
	},
	getCourse: ({ dispatch }, id) => {
		api.courses.show(id)
			.then(response => dispatch('setCourse', response.data))
			.catch(error => toast.add(error.message, 'error'))
	}

}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
}
